"use strict";

var LoggerInstance = require("js-logger").get("OneTimePasswordApi");

var AbstractApi = require("./AbstractApi");

var ApiHelper = require("../shared/ApiHelper");

var OneTimePasswordApi = class extends AbstractApi {
	//Call made to SO API
	getOneTimePasswordHtml(themeId, type) {
		if (!themeId) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `ThemeId was not specified: ${themeId}.`);
		}
		if (!type) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `Type was not specified: ${type}.`);
		}

		return this.get({
			url: "/api/onetimepassword",
			queryString: {
				themeId,
				type
			}
		});
	}

	//Call made to SO API
	generateOneTimePassword(options) {
		options = options || {};

		return this.post({
			url: "/api/onetimepassword/generate",
			data: {
				emailAddress: options.email,
				type: options.type
			}
		});
	}
};

module.exports = new OneTimePasswordApi();
